/**
 * @name ShopMessagesController
 * @description Controller for shop message templates.
 * @param {Unknown} Shop Shop service
 * @param {Unknown} Session Session service
 */
function ShopMessagesController(
  Shop,
  Session
) {
}

angular
.module('inkfinder')
.controller('ShopMessagesController', ShopMessagesController);



// WEBPACK FOOTER //
// ./components/shop/messages/shop-messages-route.controller.js